import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 你的状态
    userinfo: {
      id: null,
      username: null,
      defaultName: null,
      token: null
    },
  },
  mutations: {
    SET_USERINFO(state, userinfo) {
      state.userinfo = {
        ...userinfo,
        // defaultName: userinfo.username || `用户${userinfo.id}`
        defaultName: userinfo.username || userinfo.phone
      };
    },
    CLEAR_USERINFO(state) {
      state.userinfo = {
        id: null,
        username: null,
        defaultName: null,
        token: null
      };
    },
  },
  actions: {
    setUserinfo({ commit }, userinfo) {
      commit("SET_USERINFO", userinfo);
    },
    clearUserinfo({ commit }) {
      commit("CLEAR_USERINFO");
    },
  },
  plugins: [
    createPersistedState({
      paths: ["userinfo"], // 只持久化 userinfo 字段（可选）
    }),
  ],
});
